import { DisplayableContentState, TonometryContent } from '../../model/model'

export const isTonometryContent = (
	content?: any,
): content is TonometryContent => content?.section === 'tonometer'

export const isTonometrySection = (
	section?: DisplayableContentState,
): boolean => section?.type === 'tonometer'
